<template>
  <div class="container">
    <h2>Panel Publicaciones</h2>

    <div class="row justify-content-center">
      <SliderEdit></SliderEdit>
    </div>

    <div class="row justify-content-center mb-4">
      <NewsTable :news="news" :loading="loading.table" @get-data="getNews"></NewsTable>
    </div>
  </div>
</template>

<script>
import NewsTable from './NewsTable.vue'
import SliderEdit from './Slider.vue'
export default {
  name: 'PublicacionesDashboard',
  components: { NewsTable, SliderEdit },
  data() {
    return {
      news: {},
      loading: { table: false },
    }
  },
  mounted() {
    this.getNews()
  },
  methods: {
    getNews(page = 1) {
      const self = this
      self.loading.table = true
      axios.get('/admin/news', { params: { page } })
        .then((res) => {
          if (res.data.success) self.news = res.data.data
        })
        .finally(() => { self.loading.table = false })
    },
  },
}
</script>
